(function () {
  'use strict';

  // ---- Mobile Nav Toggle ----
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.nav-toggle');
    if (!toggle) return;

    var nav = document.querySelector('.site-nav');
    if (!nav) return;

    var isOpen = nav.classList.toggle('open');
    toggle.classList.toggle('open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));

    if (!isOpen) {
      closeAllDropdowns();
    }
  });

  // ---- Dropdown Navigation ----
  var closeTimers = {};

  function isMobile() {
    var hamburger = document.querySelector('.nav-toggle');
    return hamburger && window.getComputedStyle(hamburger).display !== 'none';
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('.nav-dropdown-wrap.open').forEach(function (wrap) {
      if (wrap !== except) {
        wrap.classList.remove('open');
        var btn = wrap.querySelector('.nav-dropdown-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function openDropdown(wrap) {
    var id = wrap.dataset.dropId;
    if (id && closeTimers[id]) {
      clearTimeout(closeTimers[id]);
      delete closeTimers[id];
    }
    closeAllDropdowns(wrap);
    wrap.classList.add('open');
    var btn = wrap.querySelector('.nav-dropdown-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function scheduleClose(wrap, delay) {
    var id = wrap.dataset.dropId;
    if (id && closeTimers[id]) {
      clearTimeout(closeTimers[id]);
    }
    closeTimers[id] = setTimeout(function () {
      wrap.classList.remove('open');
      var btn = wrap.querySelector('.nav-dropdown-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      delete closeTimers[id];
    }, delay);
  }

  // Assign IDs to each dropdown for timer tracking
  document.querySelectorAll('.nav-dropdown-wrap').forEach(function (wrap, i) {
    wrap.dataset.dropId = 'drop-' + i;

    // Desktop: hover with generous close delay
    wrap.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      openDropdown(wrap);
    });

    wrap.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      scheduleClose(wrap, 350);
    });
  });

  // Click toggle (works on both mobile and desktop)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nav-dropdown-toggle');
    if (!btn) return;

    e.preventDefault();
    var wrap = btn.closest('.nav-dropdown-wrap');
    if (!wrap) return;

    if (wrap.classList.contains('open')) {
      wrap.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      openDropdown(wrap);
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-dropdown-wrap')) return;
    if (e.target.closest('.nav-toggle')) return;

    closeAllDropdowns();

    // Also close mobile nav
    var nav = document.querySelector('.site-nav');
    var toggle = document.querySelector('.nav-toggle');
    if (nav && nav.classList.contains('open') && toggle) {
      nav.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  // Close dropdowns on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  // ---- Scroll Reveal (IntersectionObserver) ----
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    function observeReveals() {
      document.querySelectorAll('.reveal:not(.visible)').forEach(function (el) {
        observer.observe(el);
      });
    }

    observeReveals();
    document.addEventListener('shopify:section:load', observeReveals);
  }
})();
